// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3NLoR","amount":"Amount_amount__1GTNH","tip":"Amount_tip__HyBvd","tipHeader":"Amount_tipHeader__XvOfy","tipsWrap":"Amount_tipsWrap__2P0DL"};